export const ingredientStatuses = {
  draft: {
    gray: true,
    name: 'Draft',
  },
  inProgress: {
    orange: true,
    name: 'In Progress',
  },
  inTest: {
    blue: true,
    name: 'In Test',
  },
  live: {
    green: true,
    name: 'Live',
    adminOnly: true,
  },
}

export const defaultRecipeIngredients = defaultLocale => ({
  categories: [{
    title: {
      [defaultLocale]: 'For the steak',
    },
    ingredients: [],
  }, {
    title: {
      [defaultLocale]: 'For the sauce',
    },
    ingredients: [],
  }],
})
